export default {
    agreement_print: "Макулдуктун мөөрү",
    agreement_template: "Келишимдин шаблону",
    agreements: "Келишимдер",
    are_you_sure_you_want_to_delete_template: "Сиз чындыгында шаблонду жок кылгыңыз келеби?",
    bite_templates: "Жаак кабышы",
    choose_fields_for_autocomplete: "Автотолтуруу үчүн керектүү көрсөткүчтөрдү тандаңыз:",
    complaints_templates: "Даттануулар",
    consents: "Макулдуктар",
    contract_template: "Келишимдин шаблону",
    contracts: "Келишимдер",
    development: "Иштеп чыгуу",
    development_templates: "Иштеп чыгуу шаблондору",
    diseases: "Оорулар",
    diseases_templates: "Оорулардын шаблону",
    document_template_word_file_note: "Word файлын шаблон катары тиркөөгө болот. Word файлында тегдерди $ белгиси жана тармал кашаалар менен белгилеп, баш тамгаларды гана колдонушуңуз керек. Мисалы: ${FIO_CLIENT}.",
    epikriz_templates: "Эпикриз",
    found_templates_with_diagnosis: "Диагноз менен шаблондор табылган",
    full_treatment_template: "Дарылоонун шаблону",
    general_template: "Шаблон",
    generate: "Түзүү",
    generated: "Түзүлгөн",
    inspection_templates: "Текшерүү",
    medication_templates: "Дарылоо",
    not_generated: "Түзүлгөн эмес",
    objectively_templates: "Объективдүү",
    plan_treatment_template: "Дарылоонун планынын шаблону",
    plansurvey: "Текшерүү планы",
    plansurvey_templates: "Текшерүү шаблону",
    recommendations_templates: "Сунуштар",
    refresh_status_in: "{vendor} статусун жаңыртуу",
    research: "Изилдөө маалыматтары",
    research_templates: "Изилдөө маалыматтары",
    researches: "Изилдөөлөр",
    see_in_onlinecontract: "OnlineContract карап чыгуу",
    see_in_trustme: "TrustMe карап чыгуу",
    see_in_vendor: "{vendor} карап чыгуу",
    sign_via_onlinecontract: "OnlineContract аркылуу кол коюу",
    sign_via_trustme: "TrustMe аркылуу кол коюу",
    sign_via_vendor: "{vendor} аркылуу кол коюу",
    signed: "Кол коюулган",
    signed_via_onlinecontract: "OnlineContract аркылуу кол коюулган",
    signed_via_trustme: "TrustMe аркылуу кол коюулган",
    standard_diagnoses: "Стандарттык диагноздор",
    subjectively_templates: "Субъективдүү",
    teeth_medication: "Дарылоо",
    teeth_plansurvey: "Текшерүү планы",
    teeth_recommendations: "Сунуштар",
    templates_treatments_categories: "Дарылоо шаблондорунун категориялары",
    upload_signed: "Кол коюлганды жүктөө",
    uploaded: "Жүктөлгөн"
}
